import React from "react";
import TextAreaList from "../../TextareaComponent/TextAreaList";

export function AddProblemsModal({
  addTextAreaField = () => {},
  removeTextAreaField = () => {},
  handleCloseAddProblemsModal = () => {},
  handleChangeTextAreaDetails = () => {},
  saveTempProblems = () => {},
  selectedTempProblems = [],
  method
}) {
  return (
    <div
      id="patientAddProblemsModal"
      className="modal"
      tabIndex="-1"
      role="dialog"
    >
      <div
        className="modal-dialog modal-print"
        role="document"
        style={{ zIndex: "1050" }}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="hc-primary-text" style={{ fontSize: "1.25rem" }}>
              Problems Details
            </h5>
          </div>
          <div className="modal-body">
            <div className="rx-input-container input-handler">
              <TextAreaList
                data={selectedTempProblems}
                handleChangeTextAreaDetails={handleChangeTextAreaDetails}
                addTextAreaField={addTextAreaField}
                removeTextAreaField={removeTextAreaField}
                method={method}
                labels={{
                  prop: "problem",
                  placeholder: "problem"
                }}
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-hubchart btn-hubchart-primary"
              onClick={() => saveTempProblems()}
            >
              Save
            </button>
            <button
              type="button"
              className="btn btn-hubchart btn-hubchart-close"
              onClick={() => handleCloseAddProblemsModal()}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddProblemsModal;
